/**
 * NC #832 — "Wat is er nieuw" vergelijkt op de GitHub-release-tag, niet op de
 * app-versie. De app-versie springt bij elke merge (auto-bump), dus de melding
 * kwam elke dag terug met dezelfde release-notes (v2.2.0) onder een nieuw label.
 */
export const LAATST_GEZIENE_RELEASE = 'pt_last_seen_release';
/** Oude sleutel (app-versie); wordt opgeruimd, niemand leest hem meer. */
export const OUDE_SLEUTEL = 'pt_last_seen_version';

/**
 * Tonen alleen bij een andere tag dan de opgeslagen. Eerste keer (niets
 * opgeslagen): niet tonen, wel onthouden — zoals het oude gedrag.
 */
export function moetWhatsNewTonen(
  releaseVersie: string | undefined | null,
  opgeslagen: string | null
): boolean {
  return !!releaseVersie && !!opgeslagen && opgeslagen !== releaseVersie;
}
